import {pageService} from "../services/pages.services";

import AuthService from '../lib/AuthService';
let Auth = new AuthService();

export const setPage = ( page ) => dispatch => {
    dispatch({
        type: "SET_PAGE",
        page
    });
}

export const getPage = (state) => dispatch => {
    dispatch({
        type: "GET_PAGE",
        state
    });
}

export const checkLogin = (data ) => dispatch => {

    let loggedInUser = pageService.loginUser(data);

    loggedInUser.then(loggedInUser => {

        Auth.login(loggedInUser.data.response);

        dispatch({
            type: "USER_LOGGEDIN",
            loggedInUser
        });
    });
}
export const checkLogout = (data ) => dispatch => {

    dispatch({
        type: "USER_LOGGEDOUT"
    });

}
export const logActivity = (data ) => dispatch => {

    let logActivity = pageService.activityLog(data);
    console.log(logActivity);
}



// WEBPACK FOOTER //
// ./src/actions/pages.js